export default function loadWhatFix(portalCode) {
    const PRODUCER_ENGAGE = 'producer-engage-farmers-fwsprod-prod';
    const QUOTE_AND_BUY = 'quote-and-buy-farmers-fwsprod-prod';
    const ACCOUNT_MANAGEMENT = 'account-management-farmers-fwsprod-prod';

    const ProducerEngageTest = 'https://whatfix.com/2e8f27e0-ea70-11e7-9f05-04013d24cd02/embed/embed.nocache.js';
    const ProducerEngageProd = 'https://cdn.whatfix.com/prod/2e8f27e0-ea70-11e7-9f05-04013d24cd02/embed/embed.nocache.js';
    const QuoteAndBuyTest = 'https://whatfix.com/070f5250-6956-11ea-a856-bacbbe07b880/embed/embed.nocache.js';
    const QuoteAndBuyProd = 'https://cdn.whatfix.com/prod/070f5250-6956-11ea-a856-bacbbe07b880/embed/embed.nocache.js';
    const AccountManagementTest = 'https://whatfix.com/6db6c560-6956-11ea-a856-bacbbe07b880/embed/embed.nocache.js';
    const AccountManagementProd = 'https://cdn.whatfix.com/prod/6db6c560-6956-11ea-a856-bacbbe07b880/embed/embed.nocache.js';

    function getSrcUrlTest(portal) {
        switch(portal) {
            case 'PE':
                return ProducerEngageTest;
            case 'QB':
                return QuoteAndBuyTest;
            case 'AMP':
                return AccountManagementTest;
            default:
                break;
        }
    }

    function getSrcUrlProd(portal) {
        switch(portal) {
            case 'PE':
                return ProducerEngageProd;
            case 'QB':
                return QuoteAndBuyProd;
            case 'AMP':
                return AccountManagementProd;
            default:
                break;
        }
    }
    
    // This allows to inject whatfix script dynamically based on the URL
    (function(s){
        const js = document.createElement(s);
        js.setAttribute('language', 'javascript');
        js.setAttribute('ansyc', 'true');
        js.type = 'text/javascript';

        // Set src attribute based on URL
        const hostname = window.location.hostname.split(".")[0];
        if (hostname === PRODUCER_ENGAGE ||
            hostname === QUOTE_AND_BUY ||
            hostname === ACCOUNT_MANAGEMENT) {
            js.src = getSrcUrlProd(portalCode);
        } else {
            js.src = getSrcUrlTest(portalCode);
        }

        document.getElementsByTagName('head').item(0).appendChild(js);
    }('script'));
}